import React from 'react';
import bem from 'utils/bem';

import './index.sass';

const { cnBlock } = bem('white-box');

const WhiteBox = ({className, children, bg = false}) => {
    return (
        <div className={cnBlock(className, { bg })}>{children}</div>
    )
}

export default WhiteBox;

